export enum SlotTypeEnum {
  MEMBER = 'member',
  DATA = 'data',
  ADDON = 'addon',
  MODAL = 'modal',
  SUMMARY = 'summary',
  SIDEBAR = 'sidebar',
  DEVICE = 'device'
}
